// extracted by mini-css-extract-plugin
export default {"actions":"ButtonsBar_actions__W0Sfj"};